import { render, staticRenderFns } from "./Data-Correction.vue?vue&type=template&id=4a280b99"
import script from "./Data-Correction.vue?vue&type=script&lang=js"
export * from "./Data-Correction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports